import AppleLogin from 'core/components/AppleLogin'
import { appleClientId, appleChannel } from '@/config'
import useCommitThirdPartyLogin from 'core/hooks/useCommitThirdPartyLogin'
import withClientComponent from 'core/components/withClientComponent'
import notification from '@/components/notification'
import { useLocale } from 'core/components/Locale'
import { useParams } from 'next/navigation'
import { useRef } from 'react'

function AppleLoginPC(props: { className?: string; children: React.ReactNode; onSuccess: () => void }) {
  const t = useLocale()
  const { lang } = useParams()
  const thirdLoginResponseRef = useRef({})
  const commitThirdPartyLogin = useCommitThirdPartyLogin({
    onSuccess: (res) => {
      if (!res.data.data?.verifyResult) {
        notification.error({
          message: t('third_login_034'),
        })
        return
      }
      // todo: 登录成功后是否需要notification提示
      props.onSuccess(res, thirdLoginResponseRef.current)
    },
    onError: (error) => {
      console.log('telegram login error', error)
    },
  })
  return (
    <AppleLogin
      // redirectURI={`https://${window.location.hostname}/${lang}/login`} // todo: 待调整
      redirectURI={`https://${window.location.hostname}/login`}
      onLoginSuccess={(data) => {
        console.log('onLoginSuccess', data)
        thirdLoginResponseRef.current = data
        commitThirdPartyLogin('apple', appleChannel, data)
        // 传给vue pc
        sessionStorage.setItem('thirdLoginOriginalAuthInfo', JSON.stringify(data))
      }}
      clientId={appleClientId}
      className={props.className}
    >
      {props.children}
    </AppleLogin>
  )
}

export default withClientComponent(AppleLoginPC)
